import { useLocation } from 'react-router-dom';
// import AdminLayout from './AdminLayout.tsx';
import CmsLayout from './CmsLayout.tsx';
import EShopLayout from './EShopLayout.tsx';
import MinimumLayout from '@components/layout/MinimumLayout.tsx';
import AccountLayout from './AccountLayout.tsx';
import ERPLayout from './ERPLayout.tsx';
import EshopDashboardLayout from './EshopDashboardLayout.tsx';

const isErpLayoutPath = (path: string): boolean => {
  return path === '/erp' || path.startsWith('/erp/');
};

const isCrmLayoutPath = (path: string): boolean => {
  return path === '/crm' || path.startsWith('/crm/');
};

const isLegacyAccountPath = (path: string): boolean => {
  return path === '/user/account'
    || path.startsWith('/user/account/')
    || path === '/user/schedule'
    || path.startsWith('/user/schedule/');
};

const isAccountPath = (path: string): boolean => {
  return path === '/erp/account'
    || path.startsWith('/erp/account/')
    || path === '/eshop/account'
    || path.startsWith('/eshop/account/')
    || path === '/cms/account'
    || path.startsWith('/cms/account/')
    || isLegacyAccountPath(path);
};

// Determina qué layout usar según la ruta actual
const LayoutResolver: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();

  if (pathname.startsWith('/auth')) {
    return <MinimumLayout>{children}</MinimumLayout>;
  }

  if (isAccountPath(pathname)) {
    return <AccountLayout>{children}</AccountLayout>;
  }

  if (pathname.startsWith('/web') || pathname.startsWith('/site-builder') || pathname.startsWith('/cms')) {
    return <CmsLayout>{children}</CmsLayout>;
  }

  if ((pathname.startsWith('/eshop') && !pathname.startsWith('/eshop/dashboard')) || isLegacyAccountPath(pathname)) {
    return <EShopLayout>{children}</EShopLayout>;
  }

  if ((isErpLayoutPath(pathname) || isCrmLayoutPath(pathname)) && !pathname.startsWith('/eshop/dashboard')) {
    return <ERPLayout>{children}</ERPLayout>;
  }

  if (pathname.startsWith('/dashboard') || pathname.startsWith('/eshop/dashboard')) {
    return <EshopDashboardLayout>{children}</EshopDashboardLayout>;
  }

  return <MinimumLayout>{children}</MinimumLayout>;
};

export default LayoutResolver;
